import {
  CountryCheckStatus,
  CountryData,
} from "@mstys/raport-auta-client-front/components";
import { DatabaseCheck, TheftDatabaseStatus } from "./report";

/**
 * Mapa nazw krajów z API na kody ISO 3166-1 alpha-2
 * Klucze w formacie uppercase dla case-insensitive lookup
 */
const countryNameToCodeMap: Record<string, string> = {
  UKRAINE: "UA",
  UKRAINA: "UA",
  CANADA: "CA",
  KANADA: "CA",
  HUNGARY: "HU",
  WĘGRY: "HU",
  ROMANIA: "RO",
  RUMUNIA: "RO",
  CZECH: "CZ",
  CZECHY: "CZ",
  SLOVAKIA: "SK",
  SŁOWACJA: "SK",
  SLOVENIA: "SI",
  SŁOWENIA: "SI",
  POLAND: "PL",
  POLSKA: "PL",
  GERMANY: "DE",
  NIEMCY: "DE",
  FRANCE: "FR",
  FRANCJA: "FR",
  ITALY: "IT",
  WŁOCHY: "IT",
  SPAIN: "ES",
  HISZPANIA: "ES",
  NETHERLANDS: "NL",
  HOLANDIA: "NL",
  BELGIUM: "BE",
  BELGIA: "BE",
  AUSTRIA: "AT",
  SWITZERLAND: "CH",
  SZWAJCARIA: "CH",
  DENMARK: "DK",
  DANIA: "DK",
};

/**
 * Mapuje status z API na status CountryCheckStatus
 */
export const mapDatabaseStatusToCountryStatus = (
  status: string
): CountryCheckStatus => {
  switch (status) {
    case TheftDatabaseStatus.NOT_FOUND_IN_STOLEN_DB:
      return CountryCheckStatus.OK;
    case TheftDatabaseStatus.FOUND_IN_STOLEN_DB:
      return CountryCheckStatus.FOUND;
    case TheftDatabaseStatus.PROBLEM_WITH_DB_CONNECTION:
    default:
      return CountryCheckStatus.UNKNOWN;
  }
};

type TranslationFunction = (key: string, defaultValue?: string) => string;

/**
 * Generuje rekomendację na podstawie statusu
 */
const getRecommendation = (
  status: string,
  t?: TranslationFunction
): string | undefined => {
  if (t) {
    switch (status) {
      case TheftDatabaseStatus.NOT_FOUND_IN_STOLEN_DB:
        return t(
          "legal.database_status.not_found",
          "Brak wpisów w bazie pojazdów skradzionych"
        );
      case TheftDatabaseStatus.FOUND_IN_STOLEN_DB:
        return t(
          "legal.database_status.found",
          "UWAGA: Pojazd widnieje w bazie pojazdów skradzionych!"
        );
      case TheftDatabaseStatus.PROBLEM_WITH_DB_CONNECTION:
        return t(
          "legal.database_status.connection_problem",
          "Nie udało się sprawdzić - problem z połączeniem do bazy danych"
        );
      default:
        return t("legal.database_status.unknown", "Status nieznany");
    }
  }
  // Fallback bez tłumaczeń
  switch (status) {
    case TheftDatabaseStatus.NOT_FOUND_IN_STOLEN_DB:
      return "Brak wpisów w bazie pojazdów skradzionych";
    case TheftDatabaseStatus.FOUND_IN_STOLEN_DB:
      return "UWAGA: Pojazd widnieje w bazie pojazdów skradzionych!";
    case TheftDatabaseStatus.PROBLEM_WITH_DB_CONNECTION:
      return "Nie udało się sprawdzić - problem z połączeniem do bazy danych";
    default:
      return "Status nieznany";
  }
};

/**
 * Mapuje dane z API stolenDatabases na format CountryData
 */
export const mapStolenDatabasesToCountries = (
  stolenDatabases: DatabaseCheck[],
  t?: TranslationFunction
): CountryData[] => {
  return stolenDatabases.map((dbCheck) => {
    // database zawiera nazwę kraju z API (np. "UKRAINE", "Canada", "slovakia")
    const databaseName = dbCheck.database;
    // displayName zawiera tłumaczoną nazwę kraju (np. "Węgry", "Słowacja")
    const displayName = dbCheck.displayName;

    // Konwertuj do uppercase dla case-insensitive lookup
    const countryCode = countryNameToCodeMap[databaseName.toUpperCase()] || "";

    return {
      code: countryCode,
      name: displayName,
      status: mapDatabaseStatusToCountryStatus(dbCheck.status),
      recommendation: dbCheck.recommendation,
      // recommendation: getRecommendation(dbCheck.status, t),
      flagUrl: countryCode.toLowerCase(),
    };
  });
};
